/** Config do carrossel — ajustes via PR (sem .env). */
export const USABILITY_SURVEY_BASE_URL =
  'https://v3.app-indecx.com/survey-link/69c414260691950034fa55e0';
export const HOME_BANNER_CAROUSEL_INTERVAL_MS = 5000;
